// extracted by mini-css-extract-plugin
export default {"CVandSocials":"cvandsocials_CVandSocials__Vr2fW","socialLinks":"cvandsocials_socialLinks__zrdSn","email":"cvandsocials_email__Fse4w"};